import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import { createTheme } from '@mui/material/styles';
import { parsePrefillValue } from '../../common/FormCardConfig';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
  },
  textroot: {
    width: '100%',
    margin: 'auto',
  },
});

class SingleLine extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, data } = this.props;
    try {
      return (
        <div className={classes.root}>
          <TextField
            className={classes.textroot}
            variant="outlined"
            value={parsePrefillValue(data?.autoAnswer || data?.answer_data_default)}
            placeholder={(() => {
              const prefillValue = data?.autoAnswer || data?.answer_data_default;
              return prefillValue ? '' : 'Enter text...';
            })()}
            InputProps={{
              readOnly: true,
              className: classes.input,
            }}
          />
        </div>
      );
    } catch (e) {
      return <h5>Error encountered</h5>;
    }
  }
}

SingleLine.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SingleLine);
